import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=71f5c154&scoped=true"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"
import style0 from "./Bio.vue?vue&type=style&index=0&id=71f5c154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5c154",
  null
  
)

export default component.exports